export default function Footer() {
  return (
    <div style={footerStyle}>
      <div style={footerTitle}>Explore Skate Spots</div>
      <div style={footerSubtext}>
        Tap the "+" icon to add a spot or tap a marker to see info on a spot
      </div>
    </div>
  );
}

/* ---------- Styles ---------- */

const footerStyle = {
  position: "fixed",
  bottom: "10px",
  width: "100%",
  left: "50%",
  transform: "translateX(-50%)",
  padding: "50px 18px",
  background: "rgba(0,0,0,0.55)",
  backdropFilter: "blur(12px)",
  borderRadius: "14px",
  color: "white",
  zIndex: 1000,
  boxShadow: "0 6px 20px rgba(0,0,0,0.4)",
};

const footerTitle = {
  fontFamily: "Space Grotesk, sans-serif",
  fontSize: "18px",
  fontWeight: "600",
  color: "white",
  marginBottom: "4px",
  textAlign: "center",
};

const footerSubtext = {
  fontFamily: "Space Grotesk, sans-serif",
  fontSize: "18px",
  color: "#c7c7cc",
  lineHeight: "1.4",
  textAlign: "center",
};
